import { inject } from '@angular/core';
import { type HttpInterceptorFn } from '@angular/common/http';

import { TokenStore } from '@core/services';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenStore = inject(TokenStore);
  const token = request.url.includes('/auth/reset-password') ? tokenStore.getResetToken() : tokenStore.getAccessToken();

  if (token) {
    const authReq = request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + token.key),
    });

    return next(authReq);
  }

  return next(request);
};
